// validators.js

export function validatePassword(password) {
    const regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).{8,99}$/;
    return regex.test(password);
}
